interface ValidationFields {
  provaSelect: any;
  codeExam: string;
  title: string;
  subtitle: string;
  defaultLayout: boolean;
  nameDefault: string;
}

export function validateField(
  fieldName: string,
  value: string,
  extraData: { defaultLayout?: boolean } = {}
): string {
  switch (fieldName) {
    case "codeExam":
      if (!value || !value.trim()) {
        return "Código da prova é obrigatório.";
      }
      return "";
    case "title":
      if (!value || !value.trim()) {
        return "Título é obrigatório.";
      }
      return "";
    case "subtitle":
      if (!value || !value.trim()) {
        return "Subtítulo é obrigatório.";
      }
      return "";
    case "nameDefault":
      if (extraData.defaultLayout && (!value || !value.trim())) {
        return "Nome do layout padrão é obrigatório.";
      }
      return "";
    default:
      return "";
  }
}

export function validateForm(
  fields: ValidationFields
): { [key: string]: string } {
  let errors: { [key: string]: string } = {};

  if (!fields.provaSelect) {
    errors.provaSelect = "Selecione uma prova.";
  }
  errors.codeExam = validateField("codeExam", fields.codeExam);
  errors.title = validateField("title", fields.title);
  errors.subtitle = validateField("subtitle", fields.subtitle);
  if (fields.defaultLayout) {
    errors.nameDefault = validateField("nameDefault", fields.nameDefault, {
      defaultLayout: true,
    });
  }
  return errors;
}
